<template>
  <div class="home">
    <Header/>
    <Banner
      image="hero-image-personalise@2x.jpg"
      alt=""
    />
    <MembershipFormWrap formName="personalise">
      <template slot="title">
        Your Nike, Your Way
      </template>
      <template slot="description">
        Personalise your {{ store }} membership to get
        <br class="hide-mobile">more of the stuff you love.
      </template>
    </MembershipFormWrap>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import MembershipFormWrap from '@/components/MembershipFormWrap.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'personalise',
  components: {
    Header,
    Banner,
    MembershipFormWrap,
    Footer,
  },
  data() {
    return {
      store: '',
    };
  },
  created() {

  },
};
</script>
